if (!customElements.get('op-modal-video')) {
    class OpModalVideo extends HTMLElement {
        connectedCallback() {
            this.trigger = this.querySelector('[data-open-modal]');
            this.modal = document.querySelector('#' + this.dataset.modalId);
            this.video = this.modal.querySelector('video');
            this.cover = this.querySelector('[data-cover]')
            this.closeModalTrigger = this.modal.querySelector('.tw-op-modal-close');
            this.overlay = document.querySelector('#' + this.dataset.overlayId);

            if (!this.trigger || !this.modal || !this.video || !this.cover) {
                console.error('Elements missing in: ', this);
                return;
            }

            this.trigger.addEventListener('click', this.openModal);
            // this.modal.addEventListener('close', this.closeModal);
            this.closeModalTrigger.addEventListener('click', this.closeModal);
        }

        openModal = () => {
            this.classList.remove("tw-animate-shrink-fade-out");
            this.overlay.classList.remove('tw-animate-fade-out');

            this.trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.classList.add('tw-absolute', 'tw-z-50', 'tw-animate-grow-and-fade');
            this.overlay?.classList.add('!tw-block', 'tw-animate-fade-in');

            setTimeout(() => {
                this.modal.showModal();
                this.modal.classList.add('tw-animate-shrink-fade-in');
            }, 400);
        }

        closeModal = () => {
            this.modal.classList.remove('tw-animate-shrink-fade-in');
            this.classList.remove('tw-absolute', 'tw-z-50', 'tw-animate-grow-and-fade');
            this.trigger.scrollIntoView({ block: 'center' });
            this.modal.close();

            this.classList.add("tw-animate-shrink-fade-out");
            this.overlay.classList.add('tw-animate-fade-out');
            
            setTimeout(() => {
                this.overlay?.classList.remove('!tw-block', 'tw-animate-fade-in');
            }, 400);
        }
    }
    customElements.define("op-modal-video", OpModalVideo);
}